import { useState } from "react";
import { Download, Ellipsis, FilePlus2, FolderPlus, Plus, PencilLine, Upload, UserPlus, Wrench } from "lucide-react";

function ActionButton({ icon: Icon, label, onClick, primary = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition ${
        primary
          ? "border-slate-900 bg-slate-900 text-white hover:bg-slate-800"
          : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
      }`}
    >
      <Icon size={16} />
      {label}
    </button>
  );
}

export default function ClientActionBar({
  onNieuweWerkbon,
  onNieuweOpdracht,
  onContactToevoegen,
  onDocumentUploaden,
  onLocatieToevoegen,
  onBewerken,
  onImporteren,
  onExporteren,
  onDossierExporteren,
  onVerversen,
  onDeactiveren,
}) {
  const [openMore, setOpenMore] = useState(false);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3 flex flex-wrap gap-2">
        <ActionButton icon={PencilLine} label="Bewerken" onClick={onBewerken} />
        <ActionButton icon={Plus} label="Toevoegen" onClick={onNieuweOpdracht} />
        <ActionButton icon={Upload} label="Importeren" onClick={onImporteren} />
        <ActionButton icon={Download} label="Exporteren" onClick={onExporteren} />
        <ActionButton icon={Download} label="Dossier exporteren" onClick={onDossierExporteren} />
        <ActionButton icon={Ellipsis} label="Meer" onClick={() => setOpenMore((prev) => !prev)} />
      </div>

      <div className="flex flex-wrap gap-2">
        <ActionButton icon={FolderPlus} label="Nieuwe opdracht" onClick={onNieuweOpdracht} primary />
        <ActionButton icon={Wrench} label="Nieuwe werkbon" onClick={onNieuweWerkbon} primary />
        <ActionButton icon={UserPlus} label="Contactpersoon toevoegen" onClick={onContactToevoegen} />
        <ActionButton icon={FilePlus2} label="Document uploaden" onClick={onDocumentUploaden} />
        <ActionButton icon={Plus} label="Locatie toevoegen" onClick={onLocatieToevoegen} />
      </div>

      {openMore && (
        <div className="mt-3 flex flex-wrap gap-2 rounded-xl border border-slate-200 bg-slate-50 p-3">
          <button type="button" onClick={onVerversen} className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-100">
            Gegevens verversen
          </button>
          <button type="button" onClick={onDeactiveren} className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-xs font-medium text-rose-700 hover:bg-rose-100">
            Klant inactief zetten
          </button>
        </div>
      )}
    </div>
  );
}
